import Icon from "../../../../components/Icon";

const CashTaxLotDisclosure = () => (
  <div className="disclosures--info">
    <h4 className="disclosures--info__title">
      <Icon className="" name="system-warning" size="small" />
      IMPORTANT
    </h4>
    <div className="disclosures--info__content">
      <p>
        Any zero coupon bonds, matured/called bonds or securities of a different
        issue type than are held in the strategy will be treated as cash and
        invested toward the target model portfolio. The aforementioned bonds are
        assumed to be liquidated based on par value. Allspring does not
        guarantee that securities received in-kind can be liquidated and
        reserves the right to reject securities during the in-kind transfer
        account funding process. Please note, any bonds issued by Puerto Rico or
        Guam are removed from the proposal because we do not have the ability to
        transact in these securities.
      </p>
      <p>
        Equities, including individual stock, mutual funds, and ETFs, are
        assumed to be liquidated based on yesterday's close price and reinvested
        in the targeted strategy.
      </p>
      <p>Please enter adjusted cost basis in USD.</p>
    </div>
  </div>
);

export default CashTaxLotDisclosure;
